import { ArrowBack } from '@mui/icons-material';
import { Card } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { makeStyles, useTheme } from '@mui/styles';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { appName } from '../../utils/config';
import { googleMapsApiKey } from '../../utils/environment';

const center = { lat: 0.49575863961323796, lng: 37.961175232221585 };
const containerStyle = { width: `100vw`, height: `100vh` };

function EventMapScreen({ history }) {
    const { isLoaded, loadError } = useLoadScript({ googleMapsApiKey });

    return (
        <div>
            <MapHeader title={'Event Map'} />
            {loadError && 'Error Loading map'}
            {!isLoaded && 'Loading map'}
            {isLoaded && (
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={history?.location?.state?.position || center}
                    zoom={8}
                >
                    <Marker
                        position={history?.location?.state?.position || center}
                    />
                </GoogleMap>
            )}
        </div>
    );
}

const MapHeader = ({ title }) => {
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <Card
            variant="outlined"
            className="d-flex align-items-center bg-white p-2"
            style={{
                position: 'fixed',
                borderRadius: theme.shape.borderRadius,
                zIndex: 2,
                width: window.innerWidth - 16,
                height: 48,
                left: 8,
                top: 8,
            }}
        >
            <IconButton
                edge="start"
                className={classes.menuButton}
                color="inherit"
                aria-label="menu"
                onClick={() => navigate(-1)}
            >
                <ArrowBack />
            </IconButton>
            <Typography variant="h6" noWrap={true} className={classes.title}>
                {title || appName}
            </Typography>
        </Card>
    );
};

export default React.memo(EventMapScreen);

const useStyles = makeStyles((theme) => ({
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
}));
